module.exports = __webpack_public_path__ + "img/11.d819c37f.jpg";